import { __spreadArrays } from "tslib";
export function dataHooks(componentName) {
    return new Proxy({}, handler(componentName));
}
function handler(componentName) {
    return {
        get: function (obj, element) {
            return function (options) { return buildDataHook(componentName, element, options); };
        },
    };
}
function buildDataHook(cmp, element, options) {
    var strOptions = buildOptions(options).map(function (optionWithValue) { return element + "--" + optionWithValue; });
    return __spreadArrays([cmp + "__" + element], strOptions).join(' ');
}
function buildOptions(options) {
    return Object.entries(options || {})
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        if (typeof value === 'boolean' || value === null || value === undefined) {
            return value ? key : '';
        }
        return key + "_" + value;
    })
        .filter(Boolean);
}
//# sourceMappingURL=dataHooks.js.map